import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import TramOutlinedIcon from '@mui/icons-material/TramOutlined';
import ElectricRickshawOutlinedIcon from '@mui/icons-material/ElectricRickshawOutlined';
import SailingOutlinedIcon from '@mui/icons-material/SailingOutlined';
import { resolveUrl } from 'ajv/dist/compile/resolve';

export const HeaderHeight = 66;
export const HeaderHeightMobile = 88;
export const PageHeaderHeight = 50;

export const tripStatus = {
  TRIP_SCHEDULED: 'SCHEDULED',
  TRIP_STARTED: 'STARTED',
  TRIP_COMPLETED: 'COMPLETED'
};

export const gridAlignmentType = {
  TYPE_LIST: 'LIST',
  TYPE_GRID: 'GRID'
};

export const lockIcon = (color) => {
  const svg = `<svg width="24" height="24" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 14.8C4 13.1198 4 12.2798 4.30654 11.638C4.57619 11.0735 5.00645 10.6146 5.53565 10.327C6.13728 10 6.92485 10 8.5 10H14.5C16.0751 10 16.8627 10 17.4643 10.327C17.9936 10.6146 18.4238 11.0735 18.6935 11.638C19 12.2798 19 13.1198 19 14.8C19 16.9088 19 18.0912 19 20.2C19 21.8802 19 22.7202 18.6935 23.362C18.4238 23.9265 17.9936 24.3854 17.4643 24.673C16.8627 25 16.0751 25 14.5 25H11.5H8.5C6.92485 25 6.13728 25 5.53565 24.673C5.00645 24.3854 4.57619 23.9265 4.30654 23.362C4 22.7202 4 21.8802 4 20.2V14.8Z"
      fill="${color}"
    />
    <path
      d="M16.1875 10V8C16.1875 5.23858 14.0888 3 11.5 3C8.91117 3 6.8125 5.23858 6.8125 8V10M11.5 18.5C11.5 20.8431 11.5 18.1569 11.5 20.5M8.5 25C6.92485 25 6.13728 25 5.53565 24.673C5.00645 24.3854 4.57619 23.9265 4.30654 23.362C4 22.7202 4 21.8802 4 20.2V14.8C4 13.1198 4 12.2798 4.30654 11.638C4.57619 11.0735 5.00645 10.6146 5.53565 10.327C6.13728 10 6.92485 10 8.5 10H14.5C16.0751 10 16.8627 10 17.4643 10.327C17.9936 10.6146 18.4238 11.0735 18.6935 11.638C19 12.2798 19 13.1198 19 14.8C19 16.9088 19 18.0912 19 20.2C19 21.8802 19 22.7202 18.6935 23.362C18.4238 23.9265 17.9936 24.3854 17.4643 24.673C16.8627 25 16.0751 25 14.5 25H11.5H8.5Z"
      stroke="${color}"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;

  return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`;
};

export const getSvgUrl = (color, size) => {
  const svgContent = `
    <svg xmlns="http://www.w3.org/2000/svg" height="${size}" width="${size}" viewBox="0 0 24 24">
      <path d="M12 2C8.13 2 5 5.13 5 9c0 3.31 3 7.48 6.66 11.07l.34.35.34-.35C16 16.48 19 12.31 19 9c0-3.87-3.13-7-7-7zm0 9c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" fill="${color}"/>
    </svg>`;

  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgContent)}`;
};

export const getEta = (data) => {
  const etaSeconds = data ?? 0;
  const etaHours = Math.floor(etaSeconds / 3600);
  const etaMinutes = Math.floor((etaSeconds % 3600) / 60);
  if (!Number.isNaN(etaHours) && !Number.isNaN(etaMinutes)) {
    return `${etaHours} hrs ${etaMinutes} mins`;
  }
  return 'Unknown';
};

export const getTempoSvgUrl = () => {
  const svgContent = `  <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="25"
        height="24"
        viewBox="0 0 25 24"
      >
        <image
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAAAXNSR0IArs4c6QAAArJJREFUSEu9lU9oE1EQxr/ZpLWVngptomTTkwiCnsSbZFupSgUPHlQUD/ZSQcE/rYq02rSpUlGqoqAXsReFCiIeRG3FvKBHD1689NTurrqbgO2hltQkO7qbpNmmqYklZG/73sz83rz3zQyhBh/VgIHaQvxt7QfY4gEGAgT4ANSVyDIFwADwzWIMJXTxtpKbcDIJBPY1p2hpFkBTJU45m4UNlA6q6qe5cj4OxBdoPwbipwBempo4VM7JJ4deAXSQiI4YavR5OXsH4g+0X2Lim0QYMlQRLufkk5UIgAGXXRKMM6YuHpfydSCtAWWQCGFmhOO6GCoH8QcV23ZwlR3hnKmKe8Xr2UxyTpVmUmzvDyqXmTFqx2JQb1yLjrlBVYE4tyErfQTcyoJwMa6J23lQ1SA5UC8B+eBXTU2M2OtVhThKDSpnwbjrBGfuMvTYm6pDHJCsPALQA1C/qUVvrIJ4Mp77GSkzwkCnXacAdAKmkh5cmZ8R85UIpVgYRRAeZqYuADtLyPizqYld9rsWgvAwg+ZgoQeENjBmIdFDAjfbEs+rNQuRldMMPAD4O0CbAfwiom4pzR8sL3UwW08A2ghCp6mK9646+QFgU4kDOesMvhbXYpFcJnu2MWe+uownTE0czf/75NAEQIfXLlK647V4LC3RBYDPu6R70tDE+HKrt/sXgfuYsB3Ai/+BUCrTahgfE37/7hau88SznZqijR7unpkRyRXzpDUY6iSmSYAXmaUT9agXKVqyBTAOoIGJ98bV2FQhQ2UawBYmnLIWU8+kxrrjf8eE/SbThhbbuqIYXddAPjn0BaAd/3p4F8Qutv4SttdNTSw30FWT0Zkt0u9RMHcUJEyTXq4f0PV3P90BW1qUJqkBETD259VFhNeZJMKJhFhYK5NyDXhd+7Wd8es6YoVOfwCvhWQou3/mcAAAAABJRU5ErkJggg=="
          x="0"
          y="0"
          width="25"
          height="24"
        />
      </svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgContent)}`;
};

export const getTrainSvgUrl = () => {
  const svgContent = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="24" viewBox="0 0 25 24">
                    <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAAAXNSR0IArs4c6QAAAo9JREFUSEu9lV1IFFEUx39nCnoKIdBZYmctopIoKOhJwp0NoreCwCwrxYI+wEgCIago6Asisg8KesiylLQoiCB6iHZWeukDXzOCxJ1FdvQ96mHnxFiSuzs6uz50H+/93/Ob8z9n7hHKl8QS9jlV9oOuBDFCNCVb6oOMiehAPps5D+hsgZQGMBP2Y6YBReueKIOlWhX2AEeK97XXczOH5oTUWantgr4J+fJQCEKLwtFSvSipfM5xZvaLMjHj9hWEU9H2RCoueq5zNhySsPtR9oH0eG76ZGSoEkHMSt1V9BjIE89Nt4ZDrOQASKtAR951HlYNSdjtqgT3hjzXCeo1vYrtsuyguC3/BaIi7ZPZ9KNqM6lLpNpEtS8ik+QQyG5BD+bdzINqITEr2aFIb0UQ4IznOpeqhZhx+wbCiUohP4EPVUGEGpSNf+/MU/i4/RShuarg4eLo7gIKKnLdUH+VIruioIK+UIxfoHujM/nXwtfyrtMdtLiZsEdm2VDOU0a9XO16eFYwLfs20FnRf4Jy08s5XQEkZiVHFVkzVzYqfJ3MOg3BuZlI3UL1eFThp//4P0+1DAr+kkrsAj6Dfg/aP9KumJXsU6QtqgaR50K/l3UOzPVAdqH0RAaJEAQDbzLnDIRCoHmRaU0Fky3wtQa4L0IuCqrIMlQ7UZ1CjMOem345+07ZZKytb9pk+MYIaFZU2qMAM+cqegdkHcI2L+u8nQ8ipmV/BDZXGrxUp5BbXFi6dmLi1Y9Qu2LxZLeKXJVgOvpVPitBSwpbgAuglz03c7oMUhtvWm2I8QV47bnOjoVmYlr2+8AJX/0NU7nhb0VDq65+a6P4/nMMv9EbHx5bKGT5CruhUOCdoDvzbuZTEOc3MqsXKHXE2soAAAAASUVORK5CYII=" x="0" y="0" width="25" height="24"/>
                  </svg>`;

  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgContent)}`;
};
export const getTruckSvgUrl = () => {
  const svgContent = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="33" height="33" viewBox="0 0 33 33">
                    <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAAAAXNSR0IArs4c6QAAAo9JREFUWEftlj9oU1EUxr/v1sVJSjEv2iadLIqDCFJqQZOIQm0d1IqKONVi0cE/oEsd7FIdW1AR7Kou4mQtiNi8DFq1ILoIgqJNUsyfQQfRIno/CVLapHlNYlPskDe+e+45P77v3HMvsQI+rgAG1CBmXagp4amErzGyxVD15Tbsb+Frdtp9XW58sbg8O5xgeB+EB5UmtMKGbNJ9X+m+okr4g+EBCZcrTUaxK5WMjlW6r+oQ1qCJsjcBfgDgA7AGwAzAoXQi2r8YYJ4dS1FC1EEAJ4oVE9mXiUdveYFUHYJQD8SPuYIi/ABug/huDVqyn9xUycashhKFTeoEIv2ABiHcSyfdw8sIoU4RhwD2LDwpA8YJuE8BtAnsyCSijwpBqm4HiHO0eDO/kKg9APtFvMvE3U05p+avVx+ixDkl6zan4k/eLhOE7c7ZUWpWyKo9Mx2b+K8QsNiennafLxOE95zIL6jWVCI26QnhNEWOgTpZStLCdVmepbFnyrEDYls6GX3hCVFp8fnxTjA8AqH37z/dlcx9Q/gFHQCwe+6eWESJtc07txprXuWBCFM0qzulH8MAWkGM0nJEVBTweBoKvaLWE+wh9BPgVQEdAI7M5daVdCJ2acEFVgxCwCkCpwFNwtTdgbXDAEdJtUjoLqLcZxhzHNaOCTgK0kfpuoxCtHxWEsLLCicQ/kWZ9lRy/GVuBBPakUq4e73jQ+cF7M8kYqFcjBMIf4Ex3emp8fGyLrBiQU4w9BBgPaHHEvsgDaaTsWteCdcFwtssMAHhBgwaIETsDDZms+63f4ZoaNrVuAp2CISPVCwVjw0Ujt3C5P7mSJesLoBIWoOLXrfngp5YyslY6t7ak79mR2EP1XpiVpE/QDY9MX4vzKcAAAAASUVORK5CYII=" x="0" y="0" width="33" height="33"/>
                  </svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgContent)}`;
};

export const getShipSvgUrl = () => {
  const svgContent = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="18" viewBox="0 0 18 18">
                    <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAArBJREFUOE+dkltIk2EYx//P922rdRTTzXTOUZkhGoVhdHSaJSgJFXaiA42ggqSLgi6iTApKoi7sphtRO5Cg3hhIgemsm7qwiyGZ2Xlbbi4TWulO3/vE5pJN07AHXnif0+99Di9hGkkxbMkXkEtj3cR47HZaX/wthWYCMckv4/wCG/4PJMkdcSAFO2YNmq7S6exTWksxmo8yo2EmEAHHXHZrXMwUkM5YeISYGydAjObInVDxxzZLED2UFVRLksbDHCJmkaTIqAJ4PwGWf1dk2LZaJZRASKJsInGemdolIpnB2xmoUSl4E5JkzZDjqS3ua8TNIi9PrfMstBDjLIDMSEeEaoCJmS6FdSb0k8ANt957Fz09wZh2x6+6dPNJAsLBS6OACmZcJkJLBMDhtmKFvzLoypDdemd8hFHRpxfUAWSJCR0MQydXFA+jere9K5IzAUo1mVcpCvqmrJ3xObq1jMk+wWKlx/FsIA4UVqJV5YO5E0T5AGcD1B55kFAKUBOY3QBbAOpx263lcTPSGQr3AKwdcljvJxvMK4j4QFCtrh350PFDbyg4TYxel7O7K9lo3iwDxZDQEFBpv6v8o2ckoj7XF2sL6dMLLSCuBPNrMG0CQQPmZhDtBeAB4AKgBpAUPgy0ErAPgJeBbiKsIeZa0i/foZNESKsElFQiSYRAjmFHp3OJoShNDaQxQmO/5rJrgU+VLQn5o5BCy1gjhmWfHAipkKRWSR5FKAHSZxQVaWS5yZiRMvbuvf05GIuyskw5/f2ffACeJCYuPqTRaJyuQY8VhPLcnExh633rJMBlMhk2ut3fZN+o/yDlrt299cG9mnVZmcb55pLjwZKi9b6LF04ltLV1jVy/VT/vUettEVQEm4sPz7l57Zy3rMycYDlR5fX7/NRYd1Vrsw383Lmr8tVvJ+0h939OykAAAAAASUVORK5CYII=" x="0" y="0" width="18" height="18"/>
                  </svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgContent)}`;
};

export const getContainerSvgUrl = () => {
  const svgContent = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="18" viewBox="0 0 25 18">
                    <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAASCAYAAACuLnWgAAAAAXNSR0IArs4c6QAAAHBJREFUSEtjZGBgCGZgYFjDQDsQwEgHSwJBloBAAwMDQz0DA0MjlE2pv1DMG3BLYHEVwMDAsBHqNWLFiPYJtiAkSwxfcJFlILY4HrUEOakTDNbR4KJacMEyXiADA8MGtMxISIzozEhJ+TUwlgyP+gQAtQx5UeDwdqMAAAAASUVORK5CYII=" x="0" y="0" width="25" height="18"/>
                  </svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgContent)}`;
};

export const vehicleIcon = (type) => {
  if (type !== null && type !== undefined) {
    switch (type?.toUpperCase()) {
      case 'TRUCK':
        return {
          url: getTruckSvgUrl(),
          scaledSize: new window.google.maps.Size(28, 28)
        };
      case 'SHIP':
        return {
          url: getShipSvgUrl(),
          scaledSize: new window.google.maps.Size(28, 28)
        };
      case 'TRAIN':
        return {
          url: getTrainSvgUrl(),
          scaledSize: new window.google.maps.Size(28, 28)
        };
      case 'TEMPO':
        return {
          url: getTempoSvgUrl(),
          scaledSize: new window.google.maps.Size(28, 28)
        };
      case 'CONTAINER':
        return {
          url: getContainerSvgUrl(),
          scaledSize: new window.google.maps.Size(28, 28)
        };
      case 'OTHER':
        return 'truck';
      default:
        break;
    }
  }
};
